import { render } from "./ProductRegistrationEdit.vue?vue&type=template&id=4467d7de"
import script from "./ProductRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__